import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { debounceTime, filter, map } from 'rxjs/operators';

import { getLanguageisRTL } from '@core/infrastructure/state/core.selectors';
import { CategoriesSelectors } from '@features/category';
import { removeCategoriesHidden } from '@features/category/application/services/category.utils';
import { MenuCategory } from '@shared/header/models/category.model';
import { HeaderStyleService } from '@shared/header/services/header-style.service';
import { getLastSectionSelector } from '@shared/menu-categories/store/menu-categories.selectors';
import { selectUserIsLogged } from '@shared/user/store';

@Component({
    selector: 'header-container',
    templateUrl: './header-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderContainerComponent {
    private readonly store: Store = inject(Store);

    private readonly headerStyleService: HeaderStyleService = inject(HeaderStyleService);

    public readonly isWebApp = input<boolean>();

    public readonly styleHeader$$ = this.headerStyleService.headerStyle$$;

    public categories$: Observable<MenuCategory[]> = this.store.select(CategoriesSelectors.getMenuCategories)
        .pipe(
            filter((menuCategories) => menuCategories && menuCategories.length !== 0),
            map(menuCategories => removeCategoriesHidden(menuCategories)),
        );

    public lastSection$: Observable<string> = this.store.select(getLastSectionSelector).pipe(
        debounceTime(0) // FIX Expression has changed after it was checked
    );

    public isAuthenticated$: Observable<boolean> = this.store.select(selectUserIsLogged)
        .pipe(filter((isLogged) => isLogged !== null));

    public direction$ = this.store.select(getLanguageisRTL).pipe(map(isRTL => isRTL ? 'rtl' : 'ltr'));
}
